/* app/js/src/components/monitoring/event-log/monitoring-event-log.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
.container {
  margin-left: 5%;
  margin-right: 5%;
}
.container .filter {
  flex-basis: 300px;
}
.container .filter icn-dropdown {
  width: 300px;
}
.buttons {
  text-align: right;
  vertical-align: bottom;
  display: flex;
  align-items: flex-end;
}
.dates-filter {
  position: relative;
}
.errors-table {
  width: 100%;
  text-align: center;
  color: #232f3a;
}
.errors-table tr.new-error {
  background-color: #e7a5a5 !important;
}
.errors-table tr:nth-child(odd) {
  background-color: #fdfdfd;
}
.errors-table tbody tr:hover {
  background-color: #e7dfdf;
}
.errors-table th {
  border-bottom: 1px solid #232f3a;
}
.errors-table th.sort-column {
  cursor: pointer;
  text-decoration: underline;
}
.errors-table th,
.errors-table td {
  height: 2vw;
  text-align: left;
}
.errors-table th > a,
.errors-table th span,
.errors-table td > a,
.errors-table td span {
  color: #40c4ff;
  cursor: pointer;
  text-decoration: none;
}
.errors-table th > a:hover,
.errors-table th span:hover,
.errors-table td > a:hover,
.errors-table td span:hover {
  text-decoration: underline;
}
.errors-table th .status,
.errors-table td .status {
  padding: 5px;
}
.errors-table th .status.online,
.errors-table td .status.online {
  background-color: greenyellow;
}
.errors-table th .status.offline,
.errors-table td .status.offline {
  background-color: #e87474;
}
/*# sourceMappingURL=monitoring-event-log.component.css.map */
